import Reveal from "../Reveal/Reveal";
import { contact } from "../../data";
import "./contact.css";

const Contact = () => {
  if (!contact.email) return null;

  return (
    <section className="section contact center" id="contact">
      <Reveal as="h2" className="section__title">
        Contact
      </Reveal>
      <Reveal delay={90}>
        <a href={`mailto:${contact.email}`}>
          <span type="button" className="btn btn--outline">
            Email Me
          </span>
        </a>
      </Reveal>
    </section>
  );
};

export default Contact;
